"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeroAddress = exports.WeiPerEther = void 0;
exports.WeiPerEther = BigInt("1000000000000000000");
exports.ZeroAddress = "0x0000000000000000000000000000000000000000";
//# sourceMappingURL=ethers.js.map